import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndpoints } from 'src/config/api-endpoints';


@Injectable({
  providedIn: 'root'
})
export class MaritzService {

  private maritzUrlApi = ApiEndpoints.dwGetMaritzUrl;
  constructor(private http: HttpClient) { }

getMaritzUrl(walletId: string, sessionId: string, targetCatalog: string): Observable<any> {
    
    // 1. Get the Auth token exactly like your other services do
    const token = sessionStorage.getItem("walletheaders") || sessionStorage.getItem("headers");

    // 2. Set the Headers (Requires Content-Type: application/json for POST payloads)
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token
      })
    };

    // 3. Build the JSON Payload exactly as the API expects
    const payload = {
      walletID: walletId,
      sessionID: sessionId,
      targetCatalog: targetCatalog
    };

    console.log('🔗 Calling Maritz API for SSO Tokens...', payload);

    // 4. Make the POST request
    return this.http.post<any>(this.maritzUrlApi, payload, httpOptions);
  }


}
